import '../../App.css';
import React, { useContext, useEffect, useState, useRef } from "react";
import { FaTimes, FaPlus } from 'react-icons/fa';
import { TbTrash } from 'react-icons/tb';
import { SlOptionsVertical } from 'react-icons/sl';
import { Form, Row, Col, Tabs, Tab } from 'react-bootstrap';
import { ApiContext } from '../../context/ApiContext';
import { StyleContext } from '../../context/StyleContext';
import { ServicoContext } from '../../context/ServicoContext';
import ModalObterServico from './ModalObterServico';

function ModalCadastrarCapacidade({ currentPage, setopenModal, keyArvore, setKeyArvore, descricaoArvore }) {

    const { getEmpresa, AdicionarCapacidade, ListaCapacidades, Capacidades, Capacidade, setCapacidade, ListaAreaCapacidade, AreaCapacidade, Pessoas, ListaPessoa, RetornaSistemaServico, SistemaServico, RetornaTipoCapacidade, TipoCapacidade, ListaDominioMapaCalor, DominioMapaCalor } = useContext(ApiContext)
    const { ListaServico, Servicos, ObterServico, setError, setServicoAtualKey } = useContext(ServicoContext)
    const { btnVer, btnCriar, h3Demanda } = useContext(StyleContext)
    const [KeyPai, setKeyPai] = useState('')
    const [servicosSelecionados, setServicosSelecionados] = useState([]);
    const [servicoKey, setServicoKey] = useState("")
    const [servicoKeys, setServicoKeys] = useState([]);
    const servicoRef = useRef()
    const [modalEditarServico, setModalEditarServico] = useState(false)
    const [dominio, setDominio] = useState(false)

    const lightenColor = (color, percent) => {
        const num = parseInt(color.replace("#", ""), 16);
        const amt = Math.round(2.55 * percent);
        const R = (num >> 16) + amt;
        const G = ((num >> 8) & 0x00ff) + amt;
        const B = (num & 0x0000ff) + amt;
        return (
            "#" +
            (
                0x1000000 +
                (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
                (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
                (B < 255 ? (B < 1 ? 0 : B) : 255)
            )
                .toString(16)
                .slice(1)
        );
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        let updated = { ...Capacidade, [name]: value };

        if (name === "dominioCapacidadeMapaCalorKey") {
            const dominio = DominioMapaCalor?.find(d => d.key === value);
            if (dominio?.corHexadecimal) {
                updated.corHexadecimal = lightenColor(dominio.corHexadecimal, 50);
            }
        }

        setCapacidade(updated);
    };

    const handleChangeCheckbox = (event) => {
        setCapacidade({ ...Capacidade, [event.target.name]: event.target.checked })
    }

    const salvarDemanda = (e) => {
        {
            keyArvore ?
                AdicionarCapacidade(e, currentPage, keyArvore, dominio)
                    .then(() => {
                        setCapacidade([])
                        setKeyArvore("")
                        setopenModal(false)
                    })
                    .catch((error) => {
                        console.log(error)
                    })
                :
                AdicionarCapacidade(e, currentPage, KeyPai, dominio)
                    .then(() => {
                        setCapacidade([])
                        setopenModal(false)
                    })
                    .catch((error) => {
                        console.log(error)
                    })
        }
    }

    const AdicionarServico = () => {
        if (!servicoKey || servicoKey === "0") {
            setError("Selecione um serviço.");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }

        const servico = JSON.parse(servicoKey);

        const jaExiste = servicosSelecionados.some(item => item.id === servico.id);

        let novosServicos;

        if (jaExiste) {
            novosServicos = servicosSelecionados.filter(item => item.id !== servico.id);
        } else {
            novosServicos = [...servicosSelecionados, {
                servicoKey: servico.key,
                descricao: servico.descricao,
                id: servico.id,
            }];
        }

        setServicosSelecionados(novosServicos);

        const novasKeys = novosServicos.map(item => item.servicoKey);
        setServicoKeys(novasKeys);

        servicoRef.current.value = 0;
        setServicoKey("");
    };


    const ExcluirServico = (id) => {
        const servicosAtualizados = servicosSelecionados.filter(item => item.id !== id);
        setServicosSelecionados(servicosAtualizados);

        const novasKeys = servicosAtualizados.map(item => item.servicoKey);
        setServicoKeys(novasKeys);
    };

    const abrirModalServico = (servicoKey) => {
        setModalEditarServico(true)
        setServicoAtualKey(servicoKey)
        ObterServico(servicoKey)
    }


    useEffect(() => {
        getEmpresa()
        ListaAreaCapacidade()
        ListaPessoa()
        ListaServico()
        RetornaTipoCapacidade()
        ListaDominioMapaCalor()
    }, [])

    useEffect(() => {
        setCapacidade((prev) => ({
            ...prev,
            servicos: servicosSelecionados,
        }));
    }, [servicosSelecionados]);

    useEffect(() => {
        if (servicoKeys !== "") {
            RetornaSistemaServico(servicoKeys)
        }
    }, [servicoKeys])

    useEffect(() => {
        ListaCapacidades()
    }, [])

    return (
        <>
            {modalEditarServico &&
                <ModalObterServico setModalEditarServico={setModalEditarServico} />
            }

            <div className="modal-novo">
                <div className="modal-novo-interno">
                    <div className="header-modal">
                        <div>
                            <h1 className="h1-modal">Novo cadastro</h1>
                        </div>
                        <div className="btn-close-modal" onClick={() => setopenModal(false)}>
                            <FaTimes />
                        </div>
                    </div>
                    <div className="modal-content">
                        <form className="mb-3">
                            <Tabs className='mt-3 mb-3'>
                                <Tab eventKey="capacidades" title={<span>Capacidade</span>}>
                                    <Row>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Título</Form.Label>
                                            <Form.Control maxLength={100} onChange={handleChange} name="titulo" />
                                        </Form.Group>
                                    </Row>
                                    <Row>
                                        <Col xs={2}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Nível</Form.Label>
                                                <Form.Control maxLength={100} onChange={handleChange} name="nivel" />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={5}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Capacidade de Negócio Pai</Form.Label>
                                                {keyArvore ?
                                                    <Form.Select name="capacidadeNegocioPaiKey">
                                                        <option key={keyArvore} value={keyArvore}>
                                                            {descricaoArvore}
                                                        </option>
                                                    </Form.Select>
                                                    :
                                                    <Form.Select onChange={(e) => setKeyPai(e.target.value)} name="capacidadeNegocioPaiKey">
                                                        <option value="0">Selecione</option>
                                                        {Capacidades && Capacidades
                                                            .slice()
                                                            .sort((a, b) => {
                                                                if (a?.nivel && b?.nivel) {
                                                                    return a?.nivel - b?.nivel;
                                                                }
                                                                if (a?.nivel && !b?.nivel) {
                                                                    return -1;
                                                                }
                                                                if (!a?.nivel && b?.nivel) {
                                                                    return 1;
                                                                }
                                                                return a?.titulo?.localeCompare(b?.titulo);
                                                            })
                                                            .map((item) => {
                                                                return (
                                                                    <option key={item.id} value={item.key}>
                                                                        {item.nivel ? `${item.nivel} -` : ""} {item.titulo}
                                                                    </option>
                                                                )
                                                            })}
                                                    </Form.Select>
                                                }
                                            </Form.Group>
                                        </Col>
                                        <Col xs={5}>
                                            <Form.Label>Área</Form.Label>
                                            <Form.Select onChange={handleChange} name="areaKey">
                                                <option value="0">Selecione</option>
                                                {AreaCapacidade &&
                                                    AreaCapacidade?.map((item) => {
                                                        return (
                                                            <option key={item.id} value={item.key}>
                                                                {item.descricao}
                                                            </option>
                                                        )
                                                    })}
                                            </Form.Select>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Descrição</Form.Label>
                                                <Form.Control maxLength={2000} onChange={handleChange} name="descricao" as="textarea" rows={3} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Label>Business Owner</Form.Label>
                                            <Form.Select onChange={handleChange} name="pessoaKey">
                                                <option value="0">Selecione</option>
                                                {Pessoas &&
                                                    Pessoas?.map((item) => {
                                                        return (
                                                            <option key={item.id} value={item.key}>
                                                                {item.nome}
                                                            </option>
                                                        )
                                                    })}
                                            </Form.Select>
                                        </Col>
                                        <Col>
                                            <Form.Label>Arquiteto corporativo</Form.Label>
                                            <Form.Select onChange={handleChange} name="arquitetoKey">
                                                <option value="0">Selecione</option>
                                                {Pessoas &&
                                                    Pessoas?.map((item) => {
                                                        return (
                                                            <option key={item.id} value={item.key}>
                                                                {item.nome}
                                                            </option>
                                                        )
                                                    })}
                                            </Form.Select>
                                        </Col>
                                        <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Relevância para o negócio</Form.Label>
                                                <Form.Select aria-label="Default select example" value={Capacidade.relevancia} onChange={handleChange} name="relevancia">
                                                    <option value="">Selecione</option>
                                                    <option value="Habilitação de negócios">Habilitação de negócios</option>
                                                    <option value="Evolução de Negócios">Evolução de Negócios</option>
                                                    <option value="Operação de negócios">Operação de negócios</option>
                                                    <option value="Missão crítica">Missão crítica</option>
                                                    <option value="Desconhecido">Desconhecido</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Tab>
                                <Tab eventKey="sistemas" title={<span>Aplicações</span>}>
                                    <h3 className='h3-demanda' style={h3Demanda}>Aplicações vinculadas</h3>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Aplicação</th>
                                                <th>Fornecedor</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {SistemaServico?.length > 0 ? (
                                                SistemaServico.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.nome}</td>
                                                        <td>{item?.fornecedor?.fantasia}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="2">Nenhuma capacidade disponível</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </Tab>
                                <Tab eventKey="servicos" title={<span>Serviços</span>}>
                                    <h1 className='h1-modal'>Serviços</h1>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '25px' }}>
                                        <Col xs={4}>
                                            <Form.Group>
                                                <Form.Select ref={servicoRef} aria-label="Default select example" onChange={(e) => setServicoKey(e.target.value)}>
                                                    <option value="0">Selecione</option>
                                                    {Servicos &&
                                                        Servicos?.map((c) => {
                                                            return (
                                                                <option key={c.id} value={JSON.stringify(c)}>{c.descricao}</option>
                                                            )

                                                        })}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <button type="button" className="btn-dash btn-criar btn-add" style={btnCriar} onClick={() => AdicionarServico()}><FaPlus /></button>
                                    </div>
                                    <hr />
                                    <Row>
                                        <div style={{ height: '30vh', width: '100%', overflow: 'auto' }}>
                                            {servicosSelecionados.map((item, index) => {
                                                return (
                                                    <div key={index}>
                                                        <div key={index} className="content-comentario">
                                                            <div className="div-comentario">
                                                                <SlOptionsVertical style={{ marginRight: '15px' }} className='span-bsc'/>
                                                                <button className='span-bsc' type='button' style={{ border: 'none', backgroundColor: 'transparent' }} onClick={() => abrirModalServico(item.servicoKey)} >{item.descricao}</button>
                                                            </div>
                                                            <div className="div-button">
                                                                <button type="button" className="btn-del" onClick={() => ExcluirServico(item.id)}><TbTrash /></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </Row>
                                </Tab>
                                <Tab eventKey="mapacalor" title={<span>Mapa de Calor</span>}>
                                    <Row>
                                        <Col xs={6}>
                                            {['checkbox'].map((type) => (
                                                <div>
                                                    <Form.Check
                                                        type="checkbox"
                                                        id={`default-${type}`}
                                                        label="Domínio"
                                                        name="dominio"
                                                        onChange={(e) => setDominio(e.target.checked)}
                                                    />
                                                </div>
                                            ))}
                                        </Col>
                                    </Row>
                                    {dominio &&
                                        <Row>
                                            <Col xs={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Domínio da Capacidade</Form.Label>
                                                    <Form.Select
                                                        value={Capacidade.dominioCapacidadeMapaCalorKey}
                                                        onChange={handleChange}
                                                        name="dominioCapacidadeMapaCalorKey"
                                                    >
                                                        <option value="0">Selecione</option>
                                                        {DominioMapaCalor?.map((item) => (
                                                            <option key={item.id} value={item.key}>
                                                                {item.descricao}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>

                                            <Col xs={1}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Cor</Form.Label>
                                                    <Form.Control
                                                        type="color"
                                                        name="corHexadecimal"
                                                        value={Capacidade.corHexadecimal}
                                                        onChange={handleChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    }
                                    {!dominio &&
                                        <>
                                            <Row>
                                                <Col xs={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Tipo da Capacidade</Form.Label>
                                                        <Form.Select value={Capacidade.tipoCapacidade} onChange={handleChange} name="tipoCapacidade">
                                                            <option value="0">Selecione</option>
                                                            {TipoCapacidade &&
                                                                TipoCapacidade?.map((item) => {
                                                                    return (
                                                                        <option key={item.id} value={item.id}>{item.descricao}</option>
                                                                    )
                                                                })

                                                            }
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                {['checkbox'].map((type) => (
                                                    <div key={`inline-${type}`} className="mb-3">
                                                        <Form.Check
                                                            inline
                                                            label="Rodar"
                                                            name="rodar"
                                                            type={type}
                                                            id={`inline-${type}-1`}
                                                            onChange={handleChangeCheckbox}
                                                        />
                                                        <Form.Check
                                                            inline
                                                            label="Crescer"
                                                            name="crescer"
                                                            type={type}
                                                            id={`inline-${type}-2`}
                                                            onChange={handleChangeCheckbox}
                                                        />
                                                        <Form.Check
                                                            inline
                                                            label="Transformar"
                                                            name="transformar"
                                                            type={type}
                                                            id={`inline-${type}-3`}
                                                            onChange={handleChangeCheckbox}
                                                        />
                                                    </div>
                                                ))}
                                            </Row>
                                        </>
                                    }
                                </Tab>
                            </Tabs>
                            {/* <div className="checkbox-wrapper" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                            <input type="checkbox" label="Ativo" name='status' checked={Status} onChange={(e) => setStatus(e.target.checked)} className="toggleBtn" />
                            <p className="modal-status">Ativo</p>
                        </div> */}
                        </form>
                    </div>
                    <div className="footer-modal">
                        <button type="submit" className="btn-dash btn-ver" style={btnVer} onClick={() => setopenModal(false)}>Cancelar</button>
                        <button type="submit" className="btn-dash btn-criar" style={btnCriar} onClick={(e) => salvarDemanda(e)}>Salvar</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ModalCadastrarCapacidade